/* Baja Llama - size selection guard.  Added 2026-08-18.

   THE PROBLEM
   Shopify's selected_or_first_available_variant pre-checks the first in-stock
   size when a product page loads. A shopper who never opens the size selector
   still adds that size to their cart. On button ups S is position 1, so S is
   what they get. Half of every refunded S unit last year was this, caught and
   cancelled before shipping; the rest shipped and came back.

   Some products carry a "Select your size" option value that was meant to stop
   this, but it has no inventory, so Shopify treats it as unavailable and skips
   straight past it to the first real size. It never worked.

   WHAT THIS DOES
   Clears the pre-selection, hides the unbuyable placeholder, and holds Add to
   Cart closed until the shopper picks a size for themselves.

   TO REVERT: delete the one <script> line for this file in layout/theme.liquid.
*/
(function () {
  'use strict';

  var PLACEHOLDER = /select\s+your\s+size/i;
  var PROMPT = 'SELECT A SIZE';
  var satisfied = Object.create(null);
  var queued = false;

  function addToCartButtons(formId, scope) {
    var found = [];
    if (formId) {
      found = [].slice.call(document.querySelectorAll(
        '[data-add-to-cart][form="' + formId + '"], button[name="add"][form="' + formId + '"]'
      ));
    }
    if (!found.length) {
      var root = (formId && document.getElementById(formId)) ||
                 (scope.closest && scope.closest('.product-single, .product-block-list, form')) ||
                 document;
      found = [].slice.call(root.querySelectorAll('[data-add-to-cart], button[name="add"]'));
    }
    return found;
  }

  function lock(buttons) {
    buttons.forEach(function (b) {
      if (b.getAttribute('data-bl-locked') === '1') return;
      b.setAttribute('data-bl-locked', '1');
      b.setAttribute('data-bl-prev-label', b.innerHTML);
      b.setAttribute('data-bl-prev-disabled', b.disabled ? '1' : '0');
      b.innerHTML = '<span>' + PROMPT + '</span>';
      b.disabled = true;
      b.setAttribute('aria-disabled', 'true');
    });
  }

  function unlock(buttons) {
    buttons.forEach(function (b) {
      if (b.getAttribute('data-bl-locked') !== '1') return;
      var prev = b.getAttribute('data-bl-prev-label');
      if (prev !== null) b.innerHTML = prev;
      b.disabled = b.getAttribute('data-bl-prev-disabled') === '1';
      b.removeAttribute('aria-disabled');
      b.removeAttribute('data-bl-locked');
      b.removeAttribute('data-bl-prev-label');
      b.removeAttribute('data-bl-prev-disabled');
    });
  }

  function apply(group) {
    if (group.getAttribute('data-bl-guard') === '1') return;

    var radios = [].slice.call(group.querySelectorAll('input[type="radio"]'));
    if (radios.length < 2) return;

    // The placeholder is a real variant with no stock. Nobody can buy it and it
    // only adds a dead option to the row, so take it out of the picker.
    radios.forEach(function (r) {
      if (!PLACEHOLDER.test(r.value)) return;
      var holder = (r.closest && r.closest('.radio__button')) || r.parentElement;
      if (holder) holder.style.display = 'none';
      r.checked = false;
    });

    var real = radios.filter(function (r) { return !PLACEHOLDER.test(r.value); });
    if (real.length < 2) return;

    group.setAttribute('data-bl-guard', '1');

    var formId = real[0].getAttribute('form') || 'default';

    // Already chosen on this form - a re-render must not re-lock the button.
    if (satisfied[formId]) return;

    // An explicit ?variant= link means the size was already chosen elsewhere.
    if (window.location.search.indexOf('variant=') !== -1) {
      satisfied[formId] = true;
      return;
    }

    var buttons = addToCartButtons(formId, group);
    if (!buttons.length) return;

    real.forEach(function (r) { r.checked = false; });
    lock(buttons);

    group.addEventListener('change', function () {
      satisfied[formId] = true;
      unlock(buttons);
    });
  }

  function scan() {
    queued = false;
    var groups = document.querySelectorAll('[data-variant-buttons]');
    for (var i = 0; i < groups.length; i++) apply(groups[i]);
  }

  function schedule() {
    if (queued) return;
    queued = true;
    // Must be called on window - a detached reference throws in some browsers.
    if (window.requestAnimationFrame) window.requestAnimationFrame(scan);
    else window.setTimeout(scan, 0);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }

  // Quick add modals and variant re-renders mount their own pickers.
  if (window.MutationObserver) {
    new MutationObserver(schedule).observe(document.documentElement, {
      childList: true,
      subtree: true
    });
  }
})();